var site = site || {};

(function ($) {
  site.productSort = {
    init: function (productsArray) {
      var that = this;
      var $sortSelect = $('.js-product-sort');

      $sortSelect.change(function (event) {
        var $selected = $(this).find('option:selected');
        var dataSort = $selected.attr('data-sort');
        var sortedProducts = $(this).parent().next('ul').find('.mpp__product');

        that.sort(sortedProducts, dataSort);
      });
    },
    sort: function (sortedProducts, method) {
      var $parent = $(sortedProducts[0]).parent();
      var prods = [];

      if (method == 'all') {
        prods = sortedProducts;
      } else if (method == 'name') {
        prods = sortedProducts.sort(function (a, b) {
          var ta = $(a).find('a h3').text().toLowerCase();
          var tb = $(b).find('a h3').text().toLowerCase();

          return ta == tb ? 0 : ta > tb ? 1 : -1;
        });
      } else if (method == 'newest') {
        prods = sortedProducts.sort(function (a, b) {
          var ta = parseInt($(a).attr('data-newest'), 10);
          var tb = parseInt($(b).attr('data-newest'), 10);

          ta = ta == 1 || ta == 3;
          tb = tb == 1 || tb == 3;

          return ta == tb ? 0 : ta > tb ? 1 : -1;
        });
      } else if (method == 'rated') {
        prods = sortedProducts.sort(function (a, b) {
          var ta = parseFloat($(a).attr('data-product-rating'), 10) || 0;
          var tb = parseFloat($(b).attr('data-product-rating'), 10) || 0;

          return ta == tb ? 0 : ta > tb ? -1 : 1;
        });
      } else if (method == 'price-high') {
        prods = sortedProducts.sort(function (a, b) {
          var ta = parseFloat(
            $(a)
              .attr('data-price-range')
              .replace(/-.*$/, '')
              .replace(/[^0-9\.]/g, ''),
            10
          );
          var tb = parseFloat(
            $(b)
              .attr('data-price-range')
              .replace(/-.*$/, '')
              .replace(/[^0-9\.]/g, ''),
            10
          );

          return ta == tb ? 0 : ta > tb ? -1 : 1;
        });
      } else if (method == 'price-low') {
        prods = sortedProducts.sort(function (a, b) {
          var ta = parseFloat(
            $(a)
              .attr('data-price-range')
              .replace(/-.*$/, '')
              .replace(/[^0-9\.]/g, ''),
            10
          );
          var tb = parseFloat(
            $(b)
              .attr('data-price-range')
              .replace(/-.*$/, '')
              .replace(/[^0-9\.]/g, ''),
            10
          );

          return ta == tb ? 0 : ta > tb ? 1 : -1;
        });
      }

      for (var i = 0; i < prods.length; i++) {
        $(prods[i]).detach().appendTo($parent);
      }

      if ($('body').hasClass('device-mobile')) {
        site.productView.mobileMppRebuild();
      } else {
        if (typeof site.product !== 'undefined' && typeof site.product.view !== 'undefined') {
          if (typeof site.product.view.equalRowHeightFunc !== 'undefined') {
            site.product.view.equalRowHeightFunc($('.mpp__product'));
          }
          if (typeof site.product.view.miscFlagAlign !== 'undefined') {
            site.product.view.miscFlagAlign($('.mpp__product'));
          }
          if (typeof site.product.view.adjustMppProductGrid !== 'undefined') {
            site.product.view.adjustMppProductGrid();
          }
        }
      }
    }
  };
})(jQuery);
